import React, { useState, useEffect } from 'react';
import { useTranslation } from '../../../../hooks/useTranslation';
import { makeStyles, Theme, Typography } from '@material-ui/core';
import colors from '../../../../themes/main-colors';
import { useIsMobile } from '../../../../util/style-utils';
import { ToggleSwitch } from '../common/toggle-switch';
import { OutageTabs } from '../mobile-tabs-component/OutageTabs';
import { ReportOutageOtherLocationDetails } from '../report-outage-other-location-details/ReportOutageOtherLocationDetails';
import { OutageTypeExperienceDetails } from '../outage-type-experience-details/OutageTypeExperienceDetails';
import useAuth from '../../../../hooks/useAuth';
import {
  OutageMarkerView,
  useOutageLeftPanelState,
} from '../../providers/OutageLeftPanelStateProvider';

const useStyles = makeStyles((theme: Theme) => ({
  bgWindblue: {
    backgroundColor: colors.riverBlue,
  },
  switchStyles: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    gap: '5px',
  },
  switchDiv: {
    marginTop: '-4rem',
    position: 'absolute',
    marginLeft: '28rem',
  },
  root: {
    width: 44,
    height: 24,
    padding: 0,
    margin: theme.spacing(1),
  },
  thumb: {
    width: 20,
    height: 20,
  },
  font16: {
    fontSize: 16,
  },
  track1: {
    borderRadius: 32 / 2,
    backgroundColor: colors.sparkBlue,
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  switchBase1: {
    padding: 2,
    left: 0,
    '&$checked': {
      transform: 'translateX(20px)',
      color: colors.white,
      '& + $track': {
        backgroundColor: theme.palette.grey[600],
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: theme.palette.grey[600],
    },
  },
}));

export const OutageTypeExperience = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [toggleSwitch, setToggleSwitch] = useState<boolean>(false);
  const isMobile = useIsMobile();
  const { isAuthenticated } = useAuth();
  const {
    outageMarkerView,
    selectedAccountForOutage,
  } = useOutageLeftPanelState();
  const [tabNumber, setTabNumber] = useState<number>(0);
  const [outageExperienceType, setOutageExperienceType] = useState<
    string | null
  >(null);
  const hasKnownOutage = selectedAccountForOutage?.hasKnownOutage;
  useEffect(() => {
    if (hasKnownOutage && outageMarkerView !== OutageMarkerView.NoOutage) {
      setTabNumber(1);
      setToggleSwitch(true);
    }
  }, [hasKnownOutage]);

  const renderSwitchComp = () => {
    return (
      <div className={classes.switchStyles}>
        <Typography className={classes.font16}>{t('MY_ACCOUNT')}</Typography>
        <ToggleSwitch
          classes={{
            root: classes.root,
            thumb: classes.thumb,
            track: classes.track1,
            switchBase: classes.switchBase1,
          }}
          checked={toggleSwitch}
          size={'medium'}
          onChange={e => {
            setToggleSwitch(e.target.checked);
          }}
        />
        <Typography className={classes.font16}>
          {t('ANOTHER_LOCATION')}
        </Typography>
      </div>
    );
  };

  return (
    <div className={classes.bgWindblue}>
      {isMobile ? (
        isAuthenticated &&
        outageExperienceType === null &&
        outageMarkerView !== OutageMarkerView.NoOutage ? (
          <OutageTabs
            myAccountPanel={
              <OutageTypeExperienceDetails
                outageExperienceType={outageExperienceType}
                setOutageExperienceType={setOutageExperienceType}
              />
            }
            anotherLocationPanel={<ReportOutageOtherLocationDetails />}
            tabNumber={tabNumber}
            setTabNumber={setTabNumber}
          />
        ) : (
          <OutageTypeExperienceDetails
            outageExperienceType={outageExperienceType}
            setOutageExperienceType={setOutageExperienceType}
          />
        )
      ) : (
        <>
          {toggleSwitch ? (
            <>
              <div className={classes.switchDiv}>{renderSwitchComp()}</div>
              <ReportOutageOtherLocationDetails />
            </>
          ) : (
            <>
              {isAuthenticated &&
                outageExperienceType === null &&
                outageMarkerView !== OutageMarkerView.NoOutage && (
                  <div className={classes.switchDiv}>{renderSwitchComp()}</div>
                )}

              <OutageTypeExperienceDetails
                outageExperienceType={outageExperienceType}
                setOutageExperienceType={setOutageExperienceType}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};
